import React, { useCallback, useRef, useState } from 'react';
import { Button } from '../Button/index.ts';
import { T } from '../T/index.ts';
import styles from './CopyLinkRow.module.scss';
const COPY_RESET_DELAY = 1500;
const stripURLProtocol = (url)=>url.replace(/^https?:\/\//, '');
const COPY_BUTTON_LABELS = {
    copy: 'strings:roomPage.options.inviteFriends.copy',
    copied: 'strings:roomPage.copiedLink'
};
export const CopyLinkRow = ({ link, onCopyLink })=>{
    const [copyButtonState, setCopyButtonState] = useState('copy');
    const timeoutRef = useRef(null);
    const handleCopyLink = useCallback(()=>{
        onCopyLink();
        setCopyButtonState('copied');
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>setCopyButtonState('copy'), COPY_RESET_DELAY);
    }, [
        onCopyLink
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.link,
        onCopy: handleCopyLink
    }, stripURLProtocol(link)), /*#__PURE__*/ React.createElement(Button, {
        variant: "primary",
        size: "md",
        onClick: handleCopyLink
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: COPY_BUTTON_LABELS[copyButtonState]
        }
    })));
};
